$(function() {
	// get the outstanding amount
	function calculate_outstanding() {
		var checks = $('.oustanding-charges input[type=checkbox]:checked');

		var total = 0;
		checks.each(function(){
			if($(this).hasClass('select-all')) return;

			total += parseInt($(this).closest('tr').find('.amount strong').attr('data-amount'));
		});

        var subTotalElement = $('#sub-total-selected');

		subTotalElement.html(number_format(total) + ' ' + subTotalElement.data('currency').toUpperCase());
	}
	$('.oustanding-charges input[type=checkbox]').on('change', calculate_outstanding);


	function update_charges_paid_status(ids, new_status, callback){
		var callback = callback || function(){}
		// update charges
		$.post('/charges/change-status',{ 'ids' : ids.join(','), 'is_paid' : new_status }, function(){
			// remove the charges
			callback();
			$(trs).each(function(){ $(this).remove(); });
			$('input.select-all').attr('checked', false);
			$('input.select-all').trigger('change');
		});
	}

	// from charges table
	$('.change-paid-status').click(function(){
		var checks = $('.oustanding-charges input[type=checkbox]:checked');
		var is_paid_charges_page = $('.paid-charges').length > 0;

		// no charges selected
		if( checks.length == 0 ) {
			alert('No charges selected.');
			return false;
		}
		// get the new status
		var new_status = $(this).attr('data-paid');

		// get the selected ids
		var ids = [];
		var trs = [];
		checks.each(function(){
			var tr = $(this).parents('tr');
			trs.push( tr );
			ids.push( tr.attr('data-id') );
		});

		// update charges
		$.post('/charges/change-status',{ 'ids' : ids.join(','), 'is_paid' : new_status }, function(){
			var is_search = window.location.search.indexOf('?q=') != -1;

			// if is search page add/remove class
			if( is_search ) {
				if( new_status == "Y" ) {
					$(trs).each(function(){ $(this).addClass('tr-paid-charge'); });
				}else {
					$(trs).each(function(){ $(this).removeClass('tr-paid-charge'); });
				}
			}else {
				// remove the charges
				$(trs).each(function(){ $(this).remove(); });
			}

			$('input.select-all').attr('checked', false);
			$('input.select-all').trigger('change');
		});

		return false;
	});


	// get the charge link for the selected charges
	function get_checkout_link(){
		var $pay_selected_button = $('a.pay-selected');
		var checks = $('.oustanding-charges input[type=checkbox]:checked');

		$pay_selected_button.attr('href', '#').attr('target', '_self');

		if( checks.length == 0 ) {
			return;
		}

		// get the data for building the link from the current table
		var charges = [];
		var charges_ids = [];

		checks.each(function(){
			var charge_data = {}
			var tr = $(this).parent().parent();

			let charge_id = $(this).parents('tr').attr('data-id');

			charge_data['id'] = $(this).parents('tr').attr('data-id');

			charge_data['charge_name'] = tr.find('.td-project-name a').text() + ' - ' + tr.find('.charge-title span').text();
			charge_data['user'] = tr.find('.td-user').text();
			charge_data['amount'] = tr.find('.amount strong').attr('data-amount');

			charges.push(charge_data);

			charges_ids.push( charge_id );
		});


		$.post('/get-checkout-link', {
			'charges_ids' : charges_ids
		}, function(checkout_link){
			$pay_selected_button.attr('href', checkout_link.trim());
		});
	}

	$('a.pay-selected').click(function(){
		if( $(this).attr('href') == '#' ) {
			alert('No charges selected.');
			return false;
		}
		return true;
	});

	$('.oustanding-charges input[type=checkbox]').change(get_checkout_link);

	if( $('select#filter-client-id').length > 0 ) {
		$('select#filter-client-id')
			.select2({
				theme: "default outline small",
				placeholder: 'Select a client',
				ajax: {
					dataType: 'json',
    				delay: 250,
					url: '/clients/quicksearch',
					processResults: function(data, params) {
						var defaultResult = [{ id: 'all_clients', mail: null, name: 'All Clients' }];

						return {
							results: defaultResult.concat(data),
						};
					},
				},
				minimumInputLength: 1,
				templateResult: function(data) {
					return data.name;
				},
				templateSelection: function(data) {
					if (data.name) {
						return data.name;
					} else if (data.text) {
						return data.text;
					}
				},
			})
			.change(function(){
				// default for empty val()
				var new_location = '/billing';

				if( $(this).val() != '' && $(this).val() !== 'all_clients' ) {
					new_location = '/billing?client_id=' + $(this).val();
				}
				window.location.href = new_location;

			});
	}

	// delete mutilply charges
	$('.delete-charges').click(function(){
		var checks = $('.oustanding-charges input[type=checkbox]:checked');

		// no charges selected
		if( checks.length == 0 ) {
			alert('No charges selected.');
			return false;
		}

		if( !confirm('Are you sure you want to DELETE selected charges?') ) {
			return false;
		}

		// get the selected ids
		var ids = [];
		var trs = [];
		checks.each(function(){
			var tr = $(this).parents('tr');
			trs.push( tr );
			ids.push( tr.attr('data-id') );
		});

		// update charges
		$.post('/charges/delete',{ 'ids' : ids.join(',') }, function(){
			// remove the charges
			$(trs).each(function(){ $(this).remove(); });

			$('input.select-all').attr('checked', false);
			$('input.select-all').trigger('change');
		});


		return false;
	});

	// delete single charge - project page
	$('body').on('click', '.delete-charge', function(){
		if( !confirm('Are you sure you want to DELETE selected charge?') ) {
			return false;
		}

		var $parent = $(this).parents('.charge-small');
		var id = $parent.attr('data-id');

		//loading
		$parent.find('td').eq(0).find('span').html('Loading...');

		// delete
		$.post('/charges/delete',{ 'ids' : id }, function(){
			$parent.remove();
		});

		return false;
	});

});

function number_format(num){
	num += '';
	let x = num.split('.');
	let x1 = x[0];
	let x2 = x.length > 1 ? '.' + x[1] : '';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, '$1' + ',' + '$2');
	}
	return x1 + x2;
}
